module.exports = __webpack_public_path__ + "static/media/lungdis_help2328.4074e148.png";